// Leading-column layout for each scope's table, before the twelve month
// columns. The three source sheets do not share a layout — R01 carries a
// separate, merged per-district "KONTRAK (KM)" total column that R02 and R06
// do not have at all; R02 and R06 both put a per-subrow quota column right
// after MAKLUMAT, but the workbook labels it differently per sheet (R02's own
// header literally reads "KONTRAK (KM)" there, even though the cells are the
// same per-subrow quota figure R01/R06 label "KUOTA BULANAN").
//
// Column `type`s, consumed generically by both KjpTable.vue and
// KjpSummary.vue's export — neither should branch on the scope string itself:
//   - 'district'     the district name, merged down its rows
//   - 'contractTotal' the per-district contract-length total, merged down its
//                     rows (row.contractKm) — R01 only
//   - 'label'         the sub-row's own label, one per sub-row
//   - 'quota'         the sub-row's own quota, one per sub-row
//
// 'district' and 'contractTotal' are always listed first, in that order, so
// consumers can group them as one merge without special-casing which is
// present.
//
// Sibling to colors.js/titles.js rather than folded into either: this is
// workbook layout, not workbook fill colour or heading text, but it is shared
// the same way.
export const KJP_LEADING_COLUMNS = {
  R01: [
    { type: 'district', label: 'DAERAH' },
    { type: 'contractTotal', label: 'KONTRAK (KM)' },
    { type: 'label', label: 'MAKLUMAT' },
    { type: 'quota', label: 'KUOTA BULANAN' },
  ],
  R02: [
    { type: 'district', label: 'DAERAH' },
    { type: 'label', label: 'MAKLUMAT' },
    { type: 'quota', label: 'KONTRAK (KM)' },
  ],
  R06: [
    { type: 'district', label: 'DAERAH' },
    { type: 'label', label: 'MAKLUMAT' },
    { type: 'quota', label: 'KUOTA BULANAN' },
  ],
}

const MERGED_TYPES = ['district', 'contractTotal']

// The columns that merge down a district's (or the totals block's) sub-rows,
// in their configured order — always a prefix of the scope's column list.
export function mergedLeadingColumns(scope) {
  return (KJP_LEADING_COLUMNS[scope] || KJP_LEADING_COLUMNS.R01)
    .filter((c) => MERGED_TYPES.includes(c.type))
}

// The remaining columns, rendered once per sub-row rather than merged.
export function perRowLeadingColumns(scope) {
  return (KJP_LEADING_COLUMNS[scope] || KJP_LEADING_COLUMNS.R01)
    .filter((c) => !MERGED_TYPES.includes(c.type))
}
